import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { StatCard, PageHeader, Section, EmptyState } from "@/components/Primitives";
import { useNavigate } from "react-router-dom";

export default function TeacherDashboard() {
  const [tests, setTests] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [overview, setOverview] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/tests").then(r => setTests(r.data));
    api.get("/subjects").then(r => setSubjects(r.data));
    api.get("/analytics/students-overview").then(r => setOverview(r.data));
  }, []);

  const published = tests.filter(t => t.published).length;
  const draft = tests.length - published;

  return (
    <div>
      <PageHeader eyebrow="Faculty" title="Your teaching console" subtitle="Manage question banks, compose papers, grade submissions and monitor class performance." />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10">
        <StatCard label="Subjects" value={subjects.length} />
        <StatCard label="Tests drafted" value={draft} />
        <StatCard label="Tests published" value={published} accent="terracotta" />
        <StatCard label="Students tracked" value={overview.length} />
      </div>

      <Section title="Quick actions">
        <div className="grid md:grid-cols-3 gap-4">
          <Quick title="Build a paper" body="Manual selection or AI-assisted generation." onClick={() => nav("/teacher/tests/new")} />
          <Quick title="Open question bank" body="MCQs and descriptive questions, chapter-wise." onClick={() => nav("/teacher/questions")} />
          <Quick title="Publish material" body="Upload notes, PPTs, videos, lectures." onClick={() => nav("/teacher/materials")} />
        </div>
      </Section>

      <Section title="Recent tests">
        {tests.length === 0 ? <EmptyState title="No tests yet" body="Compose your first paper." /> : (
          <div className="card-academic overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-sand"><tr>
                <th className="p-4 overline text-left">Title</th>
                <th className="p-4 overline text-left">Type</th>
                <th className="p-4 overline text-left">Class</th>
                <th className="p-4 overline text-left">Questions</th>
                <th className="p-4 overline text-left">Status</th>
              </tr></thead>
              <tbody>
                {tests.slice(0, 8).map(t => (
                  <tr key={t.id} className="border-b border-stone">
                    <td className="p-4 font-medium">{t.title}</td>
                    <td className="p-4 uppercase text-xs font-mono">{t.type}</td>
                    <td className="p-4 text-mossy">{t.class_group}</td>
                    <td className="p-4 font-mono">{t.question_ids.length}</td>
                    <td className="p-4">
                      <span className={`px-2 py-0.5 text-xs ${t.published ? "bg-forest text-ivory" : "bg-sand text-forest"}`}>
                        {t.published ? "Published" : "Draft"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Section>
    </div>
  );
}

function Quick({ title, body, onClick }) {
  return (
    <button onClick={onClick} className="card-academic p-6 text-left hover:border-forest" data-testid={`quick-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="font-serif text-xl text-forest mb-1">{title}</div>
      <div className="text-sm text-mossy">{body}</div>
    </button>
  );
}
